import Button from "components/ui/Button/Button";
import PropTypes from "prop-types";
import { useHistory } from "react-router-dom";
import "components/ui/BackBar/BackBar.scss";
import { ReactComponent as IconArrowBack } from "assets/images/icons/arrow-left-short.svg";
import Session from "utils/Session";

function BackBar({ path, label, containerWidth }) {
  const history = useHistory();
  const size = containerWidth ? 'backbar--' + containerWidth : '';

  if (!path) {
    path = window.location.pathname;
    path = path.slice(0, path.lastIndexOf('/'));
  }

  const queryString = Session.load(path, 'query');
  if (queryString) {
    path = path + queryString;
  }

  return (
    <div className={ `background-primary` }>
      <div className={ `wrapper--fluid grid backbar-container` }>
        <div className={ `backbar ${size}`}>
          <Button variant={ `ghost-light` } className={ `button--small` } onClick={ () => history.push(path) }>
            <IconArrowBack/>
            { label }
          </Button>
        </div>
      </div>
    </div>
  );
}

BackBar.propTypes = {
  path: PropTypes.string,
  label: PropTypes.string.isRequired,
  containerWidth: PropTypes.string,
}

export default BackBar;
